import { Component, OnInit } from '@angular/core';
import { StoreService } from '@root/shared/service/store.service';
import { Router } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';


export const key = 'hostex_zhenguo_sync_message';

@Component({
  selector: 'host-zhenguo-sync-message',
  templateUrl: './zhenguo-sync-message.component.html',
  styleUrls: ['./zhenguo-sync-message.component.scss']
})

export class ZhenguoSyncMessageComponent implements OnInit {
  _checked = false;

  get checked() {
    return this._checked;
  }

  set checked(value) {
    this._checked = value;
    this.storeService.set(key, value, 2);
  }

  constructor(
    private storeService: StoreService,
    private modalRef: NzModalRef,
    private router: Router
  ) { }

  ngOnInit() {
  }

  onCancel() {
    this.modalRef.close();
  }

  onConfirm() {
    this.router.navigate(['/app/channel_manager'])
    this.modalRef.close();
  }

}
